import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import {
  faExpandArrowsAlt,
  faSearchMinus,
  faSearchPlus,
} from '@fortawesome/free-solid-svg-icons';
import { AbstractSecondaryToolbar } from '../../../../cross-team-shared/annotation/shared/toolbars/secondary-toolbar/abstract-secondary-toolbar';
import { KeyboardShortcutService } from '../../../../cross-team-shared/misc-services/keyboard-shortcut.service';
import { getOutputHelper } from '../../../../shared/output-helpers/get-output-helper';
import { AbstractSensorContentState2D } from '../../state/abstract-sensor-content-state-2d';
import { AbstractSensorContentStore2D } from '../../state/abstract-sensor-content-store-2d';
import { ZoomTool } from './zoom-tool';

@Component({
  selector: 'h3-zoom-secondary-bar',
  templateUrl: './zoom-secondary-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ZoomSecondaryToolbarComponent
  extends AbstractSecondaryToolbar<
    AbstractSensorContentState2D,
    AbstractSensorContentStore2D,
    ZoomTool
  >
  implements OnInit
{
  faSearchPlus = faSearchPlus;
  faSearchMinus = faSearchMinus;
  faExpandArrowsAlt = faExpandArrowsAlt;
  resetZoomTooltip!: string;
  showZoomPanelButton!: boolean;

  private store = inject(AbstractSensorContentStore2D);
  private keyboardShortcutService = inject(KeyboardShortcutService);

  ngOnInit() {
    const output = this.store.state().output;
    this.resetZoomTooltip =
      'Reset zoom' +
      this.keyboardShortcutService.getTooltipSuffix('resetSensorView');

    this.showZoomPanelButton = !getOutputHelper(
      output.type,
    ).isOrthographicProjection(output);
  }
}
